(async () => {
    const targetCountries = [
      'GR', // Greece
      'PL', // Poland
      'SI', // Slovenia
      'HR', // Croatia
      'RS', // Serbia
      'BA', // Bosnia and Herzegovina
      'LV', // Latvia
      'LT', // Lithuania
      'EE', // Estonia
      'CH', // Switzerland
    ];


    try {
      const response = await fetch('/browsing_context_suggestions.json?country[enabled]=true');
      const data = await response.json();

      const countryCode = data.detected_values?.country?.handle;

      console.log('Country:', data)

      if (!countryCode) return;

      if (targetCountries.includes(countryCode)) {
        location.href = "https://firstaustria.eu/";
      }
    } catch (error) {
      console.error("Country detection failed:", error);
    }
  })();